import { Box } from '@mui/material';
import React from 'react';
import { Button } from 'new/elements/Button';
import { CONTACT_SUPPORT_LINK } from 'js/constants/config';
import styles from './SqlAutomationsUnavailable.module.scss';

const SqlAutomationsUnavailable: React.FC = () => (
  <Box className={styles.container}>
    <Box className={styles.content}>
      <div className={styles.title}>SQL Automations Unavailable</div>
      <div className={styles.subtitle}>
        SQL Automations is not enabled for your organization. Contact Nexla support to get access.
      </div>
    </Box>
    <Button
      variant="outlined"
      color="secondary"
      component="a"
      href={CONTACT_SUPPORT_LINK}
      target="_blank"
      rel="noopener noreferrer"
    >
      Contact Support
    </Button>
  </Box>
);

export default SqlAutomationsUnavailable;
